import React, { useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaWhatsapp,
  FaRegistered,
  FaLinkedin,
} from "react-icons/fa";

import { Link } from "react-router-dom";

import "./footer.css";

function FooterComp() {

  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {

    if (email.trim() === "") {
      alert("Please enter a valid email");
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setSuccess(true);
      setLoading(false);
      setEmail("");
    }, 1200);
  };

  return (
    <footer className="footer-container">

      <div className="footer-content">

        {/* Company Info */}
        <div className="footer-section company-info">

          <div className="logo-container">
            <img
              src="/logo.png"
              alt="Dr.Jery Medico Logo"
              className="logo-image"
            />

            <span className="company-name">
              Dr. Jery Medico (Pvt) Ltd
            </span>
          </div>

          <p className="company-description">
            At Dr. Jery Medico, we provide an integrated approach to modern 
            healthcare through Medical Advisory & Applied Psychology, Medico-Legal & 
            Medical Ethics services, Digital Health Accessories with Wellness & Sports
            Biomechanics Solutions, Biomedical Engineering & Sports Biomechanics Advisory, 
            and AI Health Informatics with CSR Health Services. We combine science, technology, 
            and ethics to deliver innovative, patient-focused healthcare solutions.
          </p>

          <div className="social-icons">

            <a
              href="https://www.facebook.com/Dr.Jerish"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>

            <a
              href="https://www.instagram.com/dr.jerish/"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://wa.me/94771199190"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>

                        <a
              href="https://www.linkedin.com/in/dr-jerish-neeraj-574705103/"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>

          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">

          <h3 className="section-title-footer">
            Quick Links
          </h3>

          <ul className="link-list">

            <li>
              <Link to="/">Home</Link>
            </li>

                        <li>
              <Link to="/aboutus">
                About Us
              </Link>
            </li>

            <li>
              <Link to="/faq">
                FAQ
              </Link>
            </li>

            <li>
              <Link to="/contactus">
                Contact Us
              </Link>
            </li>

            <li>
              <Link to="/medical-advisory-applied-psychology">
                Medical Advisory & Applied Psychology
              </Link>
            </li>

            <li>
              <Link to="/medico-legal-medical-ethics">
                Medico Legal & Medical Ethics
              </Link>
            </li>

            <li>
              <Link to="/digital-health-accessories-wellness-and-sports-biomechanics-solutions">
                Digital Health Accessories Wellness &
                Sports Biomechanics Solutions
              </Link>
            </li>

            <li>
              <Link to="/biomedical-engineering-and-sports-biomechanics-advisory">
                Biomedical Engineering &
                Sports Biomechanics Advisory
              </Link>
            </li>

            <li>
              <Link to="/AI-health-informatics-csr-health-services">
                AI Health Informatics CSR Health Services
              </Link>
            </li>

          </ul>
        </div>

   

        {/* Contact Info */}
        <div className="footer-section">

          <h3 className="section-title-footer">
            Contact Us
          </h3>

          <ul className="contact-list">

                        <li className="contact-item">

              <FaMapMarkerAlt className="contact-icon" />

              {/* <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
              > */}
              
                <span>
                   177 Modera St, Colombo 01500 
                </span>
              {/* </a> */}

            </li>

            <li className="contact-item">

              <FaRegistered className="contact-icon" />

              {/* <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
              > */}
              
                <span>
                  Company Reg. No: PV 00338825    
                </span>
              {/* </a> */}

            </li>

            <li className="contact-item">

              <FaPhoneAlt className="contact-icon" />

              <a href="tel:+94771199190">
                <span>077 119 9190</span>
              </a>


            </li>

            <li className="contact-item">

              <FaEnvelope className="contact-icon" />

              <a href="mailto:info@southernrehabcare.lk">
                info@drjerymedico.com
              </a>

            </li>

          </ul>



        </div>
      </div>

      {/* Copyright */}
      <div className="copyright-section">

        <p>
          &copy; {new Date().getFullYear()} Dr. Jery Medico (Pvt) Ltd.
          All Rights Reserved. | Designed and Developed by

          <a
            className="glaxmore-link"
            href="https://www.glaxmore.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            &ensp;GLAXMORE
          </a>

        </p>

      </div>

    </footer>
  );
}

export default FooterComp;